import axios from "axios";
import { IUser } from "../store/authStore";
import { authAPI } from "./Api";

export default {
  login(request) {
    return authAPI.post("/auth/login", request);
  },
  getEsiaOrgs(oid) {
    return authAPI.get(`/auth/esia/selectorganization?oId=${oid}`);
  },
  loginEsia(oid, orgName) {
    return authAPI.post(
      `/auth/esia/LoginAsOrganization?oid=${oid}&orgName=${orgName}`,
    );
  },
  logoutEsia() {
    return authAPI.post(`/auth/esia/Logout`);
  },
  getLogoutUrl() {
    return authAPI.get(`/auth/esia/logouturl`);
  },
  logout() {
    return authAPI.post("/auth/Logout", {}).then(() => {
      localStorage.removeItem("token");
    });
  },
  getUserInfo() {
    return axios.get<IUser>("/admin/account/current");
  },
  requestResetPassword(email) {
    return authAPI.get(`/auth/passwordRecovery/forgotPassword?email=${email}`);
  },
  resetPassword(data) {
    return authAPI.put(`/auth/passwordRecovery/resetPassword`, data);
  },
  changePassword(data) {
    return authAPI.put(`/auth/passwordRecovery/changePassword`, data);
  },
  setSessionConfig(data) {
    return authAPI.post(`/auth/Settings/SetSessionConfig`, data);
  },
  getSessionConfig() {
    return authAPI.get(`/auth/Settings/GetSessionConfig`);
  },
  checkPermission(permId: number): Promise<boolean> {
    return axios.get(`/admin/userGroup/permission/${permId}`);
  },
  getCurrentSystemTime() {
    return axios.get("Admin/System/CurrentTime");
  },
};
